module.exports = ".lockedSheet {\r\n    background: #fff;\r\n}\r\n\r\n#admin-locked-timesheet-div {\r\n    min-height: 85vh;\r\n}\r\n\r\n.table-bordered>thead>tr>th {\r\n    border: 1px solid #7d5ab9 !important;\r\n}\r\n\r\n.w4 {\r\n    width: 4%;\r\n}\r\n\r\ninput[type=\"checkbox\"]:not(.css-checkbox)+label::after {\r\n    border: 1px solid #ccc !important;\r\n}\r\n\r\n.unlock_all {\r\n    text-align: center;\r\n    padding: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/loked-timesheet/loked-timesheet.component.css
// module id = ./src/app/admin/loked-timesheet/loked-timesheet.component.css
// module chunks = main